var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1143,
    height: 1082,
    viewBox: "0 0 1143 1082",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000610352,
    width: 1143,
    height: 938,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 1.72656,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 110.149,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 218.571,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 326.993,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 435.415,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 543.837,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 652.259,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 760.681,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 869.103,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 2.13049,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 116.204,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 230.278,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 344.351,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 458.425,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 572.499,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 686.572,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 800.646,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 914.72,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 1028.79,
    y: 977.525,
    width: 109.813,
    height: 103.975,
    fill: "#C9BFFE",
    stroke: "#FABBCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/Hero.444db687b175176ef468113b907b1691.svg";
export { ForwardRef as ReactComponent };